import Navbar from "../../../../../src/components/navbar/desktop/Navbar";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Navbar,
  Playground,
  Props,
  React
};